module.exports = __webpack_public_path__ + "fonts/StagSans-Medium-Italic.otf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/StagSans-Medium-Italic.otf
// module id = 1091
// module chunks = 0